var React = require('react');

function IcAwsEc2Instance (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Art"},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M34.51,40H5.49C2.463,40,0,37.537,0,34.51V5.49C0,2.463,2.463,0,5.49,0h29.02C37.537,0,40,2.463,40,5.49\n\t\t\tv29.02C40,37.537,37.537,40,34.51,40z M5.49,1.702c-2.088,0-3.787,1.699-3.787,3.787V34.51c0,2.089,1.699,3.787,3.787,3.787h29.02\n\t\t\tc2.089,0,3.787-1.699,3.787-3.787V5.49c0-2.088-1.699-3.787-3.787-3.787L5.49,1.702L5.49,1.702z"}))));
}

IcAwsEc2Instance.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 40 40","style":{"enableBackground":"new 0 0 40 40"},"xmlSpace":"preserve"};

module.exports = IcAwsEc2Instance;

IcAwsEc2Instance.default = IcAwsEc2Instance;
